<template>
  <div id="app-container">
    <component :is="resolveLayout">
      <router-view></router-view>
    </component>

    <!-- ✅ Bannière WebPush montée si connecté -->
    <NotifPermissionBanner
      v-if="isAuthenticated"
      @activer="initWebPush"
    />
  </div>
</template>

<script>
import axios from 'axios'
import store from './store'          // <-- Corrigé : './store' et non '../../store'
import { computed, watch } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'
import NotifPermissionBanner from './components/NotifPermissionBanner.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    NotifPermissionBanner,
  },
  setup(props, context) {
    const { route } = useRouter()
    const router = context.root.$router

    store.commit('initialiseStore')

    let token = store.state.token
    if (token) {
      axios.defaults.headers.common['Authorization'] = 'Token ' + token
    } else {
      axios.defaults.headers.common['Authorization'] = ''
    }

    const resolveLayout = computed(() => {
      if (route.value.name === null) return null
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      return 'layout-content'
    })

    const isAuthenticated = computed(() => store.state.isAuthenticated)

    // ── WebPush ──────────────────────────────────────────────
    const initWebPush = async () => {
      if (typeof window._initWebPush === 'function') {
        await window._initWebPush()
      } else {
        console.warn('_initWebPush non disponible sur TopUp')
      }
    }

    const autoSubscribeIfNeeded = async () => {
      if (typeof Notification === 'undefined') return
      if (Notification.permission !== 'granted') return

      const userId = store.getters.userId
      if (!userId || userId === 'anonymous') return

      const flagKey = `webpush_subscribed_${userId}`
      if (localStorage.getItem(flagKey) === 'true') return

      if (typeof window._initWebPush === 'function') {
        try {
          await window._initWebPush()
          localStorage.setItem(flagKey, 'true')
        } catch (e) {
          console.warn('❌ Échec de l’abonnement auto :', e)
        }
      }
    }

    watch(isAuthenticated, async (newVal) => {
      if (newVal) {
        await context.root.$nextTick()
        autoSubscribeIfNeeded()
      }
    }, { immediate: true })

    // ═══════════════════════════════════════════════════════
    // 🔁 Vérification périodique du blocage Top‑up
    // ═══════════════════════════════════════════════════════
    let blockCheckInterval = null

    const checkBlockStatus = async () => {
      if (!store.state.isAuthenticated) return

      try {
        const res = await axios.post('/api/v1/topup/check-topup-blocked/', {})
        if (res.data.is_blocked) {
          // Déconnexion forcée
          store.commit('setToken', '')
          store.commit('setUser', null)
          store.commit('setAuthenticated', false)
          axios.defaults.headers.common['Authorization'] = ''
          localStorage.removeItem('token')
          localStorage.removeItem('webpush_subscribed_' + store.getters.userId)

          store.commit('setSnackBarMessage', 'Your account has been blocked by a manager. You have been logged out.')
          store.commit('setSnackBarColor', 'red darken-4')
          store.commit('activateSnackBar', true)

          router.push({ name: 'login' })
        }
      } catch (err) {
        console.warn('Block status check failed:', err)
      }
    }

    const startBlockCheck = () => {
      stopBlockCheck()
      blockCheckInterval = setInterval(checkBlockStatus, 30000)
    }

    const stopBlockCheck = () => {
      if (blockCheckInterval) {
        clearInterval(blockCheckInterval)
        blockCheckInterval = null
      }
    }

    watch(isAuthenticated, (newVal) => {
      if (newVal) {
        checkBlockStatus()
        startBlockCheck()
      } else {
        stopBlockCheck()
      }
    }, { immediate: true })

    return {
      resolveLayout,
      isAuthenticated,
      initWebPush,
    }
  },
}
</script>

<style>
body.chat-open {
  overflow: hidden;
  height: 100%;
}
body.chat-open footer,
body.chat-open .footer,
body.chat-open .site-footer,
body.chat-open [class*="footer"],
body.chat-open [class*="copyright"] {
  display: none !important;
}
</style>
